import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaCheck } from 'react-icons/fa';
import './Partners.css';

// Partner band shown right under the hero. Static content: edit here when partnerships change.
const Partners = () => {
  const { t } = useTranslation();

  return (
    <section className="partners" aria-label={t('partners.eyebrow')}>
      <div className="container partners-inner">
        <p className="partners-eyebrow">{t('partners.eyebrow')}</p>
        <img
          className="partners-logo"
          src="/assets/images/logos/uipath-logo.png"
          alt="UiPath"
          width="147"
          height="48"
        />
        <ul className="partners-certs">
          <li><FaCheck aria-hidden="true" />{t('partners.agentic')}</li>
          <li><FaCheck aria-hidden="true" />{t('partners.developers')}</li>
        </ul>
      </div>
    </section>
  );
};

export default Partners;
